import { render, staticRenderFns } from "./ReservationLog.vue?vue&type=template&id=0535b175&"
import script from "./ReservationLog.vue?vue&type=script&lang=js&"
export * from "./ReservationLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports